export const resolveExpenseFeeStatusClass = (row) => {
  const status = String(row?.status || '').trim().toLowerCase();
  if (status === 'pagado') {
    return 'app-status-active';
  }

  if (status === 'por aprobar' || status === 'no aprobado') {
    return 'expenses-status-pill--pending-approval';
  }

  if (status === 'pendiente' || status === 'por aprobar' || status === 'no aprobado') {
    return 'app-status-inactive';
  }

  return 'app-status-inactive';
};

export const isExpenseFeePaid = (row) => {
  const statusCode = String(row?.status_code || '').trim().toUpperCase();
  if (statusCode !== '') {
    return statusCode === 'DONE';
  }

  return String(row?.status || '').trim().toLowerCase() === 'pagado';
};

export const isExpenseFeePending = (row) => {
  const status = String(row?.status || '').trim().toLowerCase();
  return status === 'pendiente' || status === 'por aprobar' || status === 'no aprobado';
};

export const hasExpenseFeeRelatedPayment = (row) => {
  const paymentId = Number(row?.payment_id || 0);
  const paymentCode = String(row?.payment?.code || '').trim();

  return paymentId > 0 || paymentCode !== '';
};

export const isExpenseFeeUnapproved = (row) => {
  const status = String(row?.status || '').trim().toLowerCase();
  if (status === 'por aprobar' || status === 'no aprobado') {
    return true;
  }

  const approved = row?.is_approved;
  if (approved === true) {
    return false;
  }

  if (approved === false) {
    return true;
  }

  if (approved === undefined || approved === null || approved === '') {
    return false;
  }

  return Number(approved) === 0;
};

export const canExpenseFeeDelete = (row) => {
  return !hasExpenseFeeRelatedPayment(row) && isExpenseFeeUnapproved(row);
};

export const canExpenseFeeUnapprove = (row) => {
  return !hasExpenseFeeRelatedPayment(row) && !isExpenseFeeUnapproved(row) && !isExpenseFeePaid(row);
};

export const showExpenseFeeReferenceAction = (row) => {
  return !hasExpenseFeeRelatedPayment(row) && isExpenseFeePending(row);
};

export const resolveExpenseFeeReferenceActionLabel = (row) => {
  return isExpenseFeeUnapproved(row) ? 'Aprobar' : 'Pagar';
};
